export default __webpack_public_path__ + "static/media/silver-icon.d9b93dee.png";